import React from 'react';
import { useLocation } from 'react-router-dom';
import { WorkData } from '../data';
import { thumbnailImagePath } from '../utils/imageUtils';
import { useFilteredWorks } from '../hooks/useWorkData';
import { useWorkNavigation } from '../hooks/useNavigation';

function Works() {
  const location = useLocation();
  const navigateToWork = useWorkNavigation();

  // Extract category from pathname
  const category = React.useMemo(() => {
    const path = location.pathname;
    if (path === "/collage") return "collage";
    if (path === "/drawing") return "drawing";  
    if (path === "/sculpture") return "sculpture";
    return undefined; // Show all works
  }, [location.pathname]);

  const works = useFilteredWorks(category);
  
  return (
    <div className="images">
      {works.map((work: WorkData) => (
        work.video ? (
          <video key={work.name}
            className="image image-video"
            onClick={() => navigateToWork(work.name)}
            src={"/" + work.video}
            poster={"/" + work.image}
            autoPlay
            loop
            muted
            playsInline
            aria-label={work.name}
            style={{ objectFit: "cover" }} />
        ) : (
          <img key={work.name}
            className="image"
            onClick={() => navigateToWork(work.name)}
            src={thumbnailImagePath(work.image)}
            alt={work.name} />
        )
      ))}
    </div>
  );
}

export default Works;